import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import CustomAlert from "../../shared/CustemAlert";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  increment,
  counter,
  moamad,
  rltvOptions,
  departmentsList,
  hagsha_aharon,
}) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [newRltv, setNewRltv] = useState({
    full_name: "",
    idz: null,
    rltv_type: "",
    job: "",
    department: 0,
    moamad: moamad.id,
  });
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewRltv((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewRltv((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosPrivate.post(baseURL + "relative/", newRltv);
      increment();
      setShowCustomAlert(true);
    } catch (err) {
      // Handle errors
    }
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="container">
          <div className="card text-dark bg-light p-3 border">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}

            <h5
              onClick={() => {
                setSaeef("4-7");
                setShowHelp(true);
              }}
            >
              הקירבה של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              {moamad.signatrue_date}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>

          {!readOnly && (
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12} md={8}>
                    <div className="form-group">
                      <label htmlFor="full_name" className="required-label">
                        שם הקרוב
                      </label>
                      <input
                        type="text"
                        name="full_name"
                        className="form-control"
                        id="full_name"
                        value={newRltv.full_name}
                        placeholder="תקליד שם קרוב המשפחה"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="form-group">
                      <label htmlFor="idz"> ת"ז </label>
                      <input
                        type="number"
                        name="idz"
                        className="form-control"
                        id="idz"
                        value={newRltv.idz}
                        placeholder="תקליד תז של הקרוב"
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={8}>
                    <div className="form-group">
                      <label htmlFor="job" className="required-label">
                        תפקיד
                      </label>
                      <input
                        type="text"
                        name="job"
                        className="form-control"
                        id="job"
                        value={newRltv.job}
                        placeholder="תקליד תפקיד"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="form-group">
                      <label htmlFor="rltv_type" className="required-label">
                        בחר סוג הקירבה
                      </label>
                      <select
                        name="rltv_type"
                        onChange={handleChange}
                        value={newRltv.rltv_type}
                        className="form-control"
                        required
                      >
                        <option key="0" value="">
                          בחר סוג
                        </option>
                        {rltvOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12}>
                    <div className="form-group">
                      <label htmlFor="department" className="required-label">
                        מחלקה
                      </label>
                      <select
                        name="department"
                        onChange={handleDDSChange}
                        value={newRltv.department}
                        className="form-control"
                        required
                      >
                        <option value="">בחר מחלקה</option>
                        {departmentsList?.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
                <label>
                  {" "}
                  <span
                    style={{ textDecoration: "underline", fontWeight: "bold" }}
                  >
                    בשדה מחלקה:
                  </span>{" "}
                  -במקרה שקרוב המשפחה הוא נבחר ציבור נא לבחור{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    במועצת הרשות -נבחרים
                  </span>
                </label>
                <br />
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת קירבה למועמד"
                    alertBody="הקירבה נוספה בהצלחה"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </center>
    </div>
  );
}
